// @ts-nocheck
export default defineNuxtRouteMiddleware((to, from) => {
  if (process.server) { return }
  const { $lang } = useNuxtApp()
  const authStore = useAuthStore()

  const redirectLink = {
    name: `${$lang}-login`,
    query: { redirect: to.path }
  }

  if (!authStore.loggedIn) {
    if (from.name?.includes('-login')) {
      return document.location.reload()
    }
    return navigateTo(redirectLink)
  }
})
